/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Career } from '../../models/career';
import { CareerApiRespModel } from '../../models/career-api-resp-model';

export interface ApiMasterCareerAddPost$Params {
      body?: Career
}

export function apiMasterCareerAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterCareerAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CareerApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCareerAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CareerApiRespModel>;
    })
  );
}

apiMasterCareerAddPost.PATH = '/api/Master/Career/Add';
